import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
    AccessSolicitudImporGuard,
    AccessSolicitanteImporGuard,
    AccessProductoImporGuard,
    ActionEstadoImporGuard,
    AccessDocumentosImporGuard,
    AccessSeguimientoImporGuard,
    AccessEmbalajeImporGuard,
    AccessRechazoParcialImporGuard,
} from '../_classes/access.guard';
import { AnulacionEditComponent } from './anulacion/anulacion-edit.component';
import { SolicitanteDetailComponent } from './datosbasicos/solicitante/solicitante-detail.component';
import { SolicitudEditComponent } from './datosbasicos/solicitud-edit.component';
import { DocumentosEditComponent } from './documentos/documentos-edit.component';
import { DocumentosListComponent } from './documentos/documentos-list.component';
import { EnvioComponent } from './envio/envio.component';
import { InspeccionesComponent } from './inspecciones/inspecciones.component';
import { PreduaEditComponent } from './predua/predua-edit.component';
import { PreviaInspectorEditComponent } from './previaInspector/previaInspector-edit.component';
import { EmbalajeEditComponent } from './productos/embalajes-edit.component';
import { ProductoEditComponent } from './productos/productos-edit.component';
import { ProductosSolicitudListComponent } from './productos/productos-list.component';
import { SeguimientoEditComponent } from './seguimiento/seguimiento-edit.component';
import { SeguimientoListComponent } from './seguimiento/seguimiento-list.component';
import { TasasComponent } from './tasas/tasas.component';
import { TipoSolicitudListComponent } from './tipossolicitudes/tiposolicitud-list.component';
import { EnumCodigosTwTcAcciones } from './types/enum';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { LaboratorioWrapperComponent } from './laboratorio/laboratorio-wrapper/laboratorio-wrapper.component';
import { LaboratorioDocumentosEditComponent } from './laboratorio/laboratorio-documentos-edit/laboratorio-documentos-edit.component';
import { RechazoParcialComponent } from './inspecciones/rechazoparcial.component';
import { ImportadorLugarDestinoWrapperComponent } from './importador-lugardestino/importador-lugardestino-wrapper/importador-lugardestino-wrapper.component';

const solicitudesRoutes: Routes = [
    {
        path: 'importacion/solicitud',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'IMPORTACIÓN',
            //menu1: 'Solicitudes'//,//,
            //,
            overridePath: 'importacion/solicitudes',
        },
        children: [
            //{
            //    path: '',
            //    component: BuscadorSolicitudListComponent,
            //},
            { path: '', redirectTo: 'tipossolicitudes', pathMatch: 'full' },
            {
                path: 'tipossolicitudes',
                component: TipoSolicitudListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Tipo Solicitud',
                    actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD,
                },
            },
            {
                path: 'datosbasicos/create',
                data: {
                    breadcrumb: 'Nueva',
                },
                children: [
                    {
                        path: '',
                        component: SolicitudEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD,
                            reuseComponent: false,
                        },
                    },
                    {
                        path: 'solicitante/:id',
                        component: SolicitanteDetailComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD,
                            breadcrumb: 'Detalle Solicitante',
                        },
                    },
                ],
            },
            {
                path: 'datosbasicos/:id',
                data: {
                    breadcrumb: 'Datos Básicos',
                },
                children: [
                    {
                        path: '',
                        component: SolicitudEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudImporGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS,
                            reuseComponent: false,
                        },
                    },
                    {
                        path: 'solicitante/:id',
                        component: SolicitanteDetailComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitanteImporGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS,
                            breadcrumb: 'Detalle Solicitante',
                        },
                    },
                ],
            },

            //MENU PRODUCTOS
            {
                path: 'productos/:id',
                data: {
                    breadcrumb: 'Productos',
                },
                children: [
                    {
                        path: '',
                        component: ProductosSolicitudListComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudImporGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS,
                        },
                    },
                    {
                        path: 'create',
                        component: ProductoEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudImporGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD,
                        },
                    },
                    {
                        path: 'producto/:idprod',
                        component: ProductoEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessProductoImporGuard()],
                        data: {
                            breadcrumb: 'Editar Producto',
                            actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS,
                        },
                    },
                    {
                        path: 'create_packing',
                        component: EmbalajeEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudImporGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD,
                        },
                    },
                    {
                        path: 'embalaje/:idemb',
                        component: EmbalajeEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessEmbalajeImporGuard()],
                        data: {
                            breadcrumb: 'Editar Embalaje',
                            actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS,
                        },
                    },
                ],
            },
            {
                path: 'importadorlugardestino/:id',
                data: {
                    breadcrumb: 'Importador | Lugar Destino',
                },
                children: [
                    {
                        path: '',
                        component: ImportadorLugarDestinoWrapperComponent,
                        canActivate: [LoginGuard(), ActionEstadoImporGuard(), AccessSolicitudImporGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_IMPORTADOR_LUGAR_DESTINO,
                        },
                    },
                ],
            },
            {
                path: 'anulacion/:id',
                component: AnulacionEditComponent,
                canActivate: [LoginGuard(), ActionEstadoImporGuard(), AccessSolicitudImporGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_ANULACION,
                    menu0: 'Anulación',
                },
            },
            {
                path: 'previa/:id',
                component: PreviaInspectorEditComponent,
                canActivate: [LoginGuard(), ActionEstadoImporGuard(), AccessSolicitudImporGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_PREVIA,
                    menu0: 'Previa',
                },
            },
            {
                path: 'envio/:id',
                component: EnvioComponent,
                canActivate: [LoginGuard(), ActionEstadoImporGuard(), AccessSolicitudImporGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO,
                    menu0: 'Envío',
                },
            },
            {
                path: 'predua/:id',
                component: PreduaEditComponent,
                canActivate: [LoginGuard(), ActionEstadoImporGuard(), AccessSolicitudImporGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_PREDUA,
                    menu0: 'PreDua',
                },
            },
            {
                path: 'tasas/:id',
                component: TasasComponent,
                canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudImporGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_TASAS,
                    menu0: 'Tasas',
                },
            },
            {
                path: 'inspecciones/:id',
                data: {
                    breadcrumb: 'Inspecciones',
                },
                children: [
                    {
                        path: '',
                        component: InspeccionesComponent,
                        canActivate: [LoginGuard(), ActionEstadoImporGuard(), AccessSolicitudImporGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_INSPECCIONES,
                        },
                    },
                    {
                        path: 'rechazoparcial',
                        component: RechazoParcialComponent,
                        canActivate: [LoginGuard(), ActionEstadoImporGuard(), AccessRechazoParcialImporGuard()],
                        data: {
                            breadcrumb: 'Rechazo Parcial',
                            actionCode: EnumCodigosTwTcAcciones.VER_RECHAZO_PARCIAL,
                        },
                    },
                ],
            },
            {
                path: 'laboratorio/:id',
                data: {
                    breadcrumb: 'Laboratorio',
                },
                children: [
                    {
                        path: '',
                        component: LaboratorioWrapperComponent,
                        canActivate: [LoginGuard(), ActionEstadoImporGuard(), AccessSolicitudImporGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_LABORATORIO,
                        },
                    },
                    {
                        path: 'documento',
                        component: LaboratorioDocumentosEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoImporGuard()],
                        data: {
                            breadcrumb: 'Nuevo documento',
                            actionCode: EnumCodigosTwTcAcciones.VER_PANTALLA_DOCUMENTO_LABORATORIO,
                        },
                    },
                    {
                        path: 'documento/:idDocumento',
                        component: LaboratorioDocumentosEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoImporGuard()],
                        data: {
                            breadcrumb: 'Editar documento',
                            actionCode: EnumCodigosTwTcAcciones.VER_PANTALLA_DOCUMENTO_LABORATORIO,
                        },
                    },
                ],
            },
            {
                path: 'documentos/:id',
                data: {
                    breadcrumb: 'Documentos',
                },
                children: [
                    {
                        path: '',
                        component: DocumentosListComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudImporGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS,
                        },
                    },
                    {
                        path: 'create',
                        component: DocumentosEditComponent,
                        canActivate: [LoginGuard(), ActionEstadoImporGuard(), AccessSolicitudImporGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS,
                        },
                    },
                    {
                        path: 'detalleDocumento/:idDocumento',
                        component: DocumentosEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessDocumentosImporGuard()],
                        data: {
                            breadcrumb: 'Detalle Documento',
                            actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS, //jlht, la he metido yo. Quitar??
                        },
                    },
                ],
            },
            {
                path: 'seguimientos/:id',
                data: {
                    breadcrumb: 'Seguimiento',
                },
                children: [
                    {
                        path: '',
                        component: SeguimientoListComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudImporGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO,
                        },
                    },
                    {
                        path: 'create',
                        component: SeguimientoEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudImporGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO,
                        },
                    },
                    {
                        path: 'create/inspecciones',
                        component: SeguimientoEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudImporGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO,
                        },
                    },
                    {
                        path: 'detalleseguimiento/:idSeguimiento',
                        component: SeguimientoEditComponent,
                        canActivate: [LoginGuard(), AccessSeguimientoImporGuard()],
                        data: {
                            breadcrumb: 'Detalle Seguimiento',
                        },
                    },
                ],
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(solicitudesRoutes)],
    exports: [RouterModule],
})
export class SolicitudesRoutingModule {}
